import { inject, Injectable, signal } from '@angular/core';
import { LimitedFeatures } from '../models/pack.models';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { SalesLeadData, SalesLeadResponse } from '../models/discovery.models';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ContactModalService {
  private readonly baseUrl = environment.apiUrl + '/discovery';
  show = signal<boolean>(false);
  content = signal<LimitedFeatures | null>(null);
  http = inject(HttpClient);

  open(limitedFeatures?: LimitedFeatures) {
    this.show.set(true);
    this.content.set(limitedFeatures ?? null);
  }
  close() {
    this.show.set(false);
    this.content.set(null);
  }

  /**
   * Envoie une demande de contact commercial
   */
  contactSales(data: SalesLeadData): Observable<SalesLeadResponse> {
    return this.http
      .post<SalesLeadResponse>(`${this.baseUrl}/contact-sales`, data)
      .pipe(
        tap(() => {
          this.close();
        }),
      );
  }
}
